'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receivedCommandMessage = exports.switchToChannel = exports.closePubNubConversation = exports.receivedIncomingMessage = exports.chatInputChanged = exports.setCurrentChannel = exports.receivedChatConfig = exports.requestedChatConfigFailed = exports.requestedChatConfig = undefined;
exports.selectNextChannelForStatus = selectNextChannelForStatus;
exports.receivedPubNubMessage = receivedPubNubMessage;
exports.recievedPrivateOpenChannel = recievedPrivateOpenChannel;

var _reduxActions = require('redux-actions');

var _transmute = require('transmute');

var _underscore = require('underscore');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _PubNubMessageSerializer = require('conversations-schema/serializers/PubNubMessageSerializer');

var _conversationSelectors = require('conversations-core/selectors/conversationSelectors');

var _pubNubHelpers = require('conversations-core/utils/pubNubHelpers');

var _ConversationsActions = require('conversations-core/actions/ConversationsActions');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

var _ChatHistoryActions = require('conversations-core/actions/ChatHistoryActions');

var _pollFunctionWithExponentialBackoff = require('conversations-lib/functions/pollFunctionWithExponentialBackoff');

var _pollFunctionWithExponentialBackoff2 = _interopRequireDefault(_pollFunctionWithExponentialBackoff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// chat config
var requestedChatConfig = exports.requestedChatConfig = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_CHAT_CONFIG);

var requestedChatConfigFailed = exports.requestedChatConfigFailed = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_CHAT_CONFIG_FAILED);

var receivedChatConfig = exports.receivedChatConfig = (0, _reduxActions.createAction)(_ActionTypes2.default.GET_CHAT_CONFIG_SUCCEEDED);

var setCurrentChannel = exports.setCurrentChannel = (0, _reduxActions.createAction)(_ActionTypes2.default.SET_CURRENT_CHANNEL, function (channel) {
  return { channel: channel };
});

function selectNextChannelForStatus(channel) {
  return function (dispatch, getState) {
    var status = (0, _conversationSelectors.getChatFilterSetting)(getState());
    var channels = (0, _conversationSelectors.getConversationsByStatusType)(getState(), status).keySeq();
    var channelIndex = channels.indexOf(channel);

    var nextChannel = void 0;
    var isOnyChanel = channels.size === 1;
    var isLastChannel = channelIndex === channels.size - 1;

    if (isOnyChanel) {
      nextChannel = null;
    } else if (isLastChannel) {
      nextChannel = channels.get(channelIndex - 1);
    } else {
      nextChannel = channels.get(channelIndex + 1);
    }

    dispatch(setCurrentChannel(nextChannel));
  };
}

var chatInputChanged = exports.chatInputChanged = (0, _reduxActions.createAction)(_ActionTypes2.default.CHAT_INPUT_CHANGED);

// sending/recieving messages

var receivedIncomingMessage = exports.receivedIncomingMessage = (0, _reduxActions.createAction)(_ActionTypes2.default.RECEIVED_INCOMING_MESSAGE);

function receivedPubNubMessage(_ref) {
  var messageJson = _ref.message,
      channel = _ref.channel;

  return function (dispatch, getState) {
    var offset = (0, _clientSelectors.getServerTimeOffsetInMs)(getState());

    var message = (0, _transmute.pipe)(_PubNubMessageSerializer.deserialize, (0, _PubNubMessageModel.applyTimestampOffset)(-offset))(messageJson);

    dispatch(receivedIncomingMessage({
      message: message,
      channel: channel
    }));
  };
}

var closePubNubConversation = exports.closePubNubConversation = (0, _reduxActions.createAction)(_ActionTypes2.default.CLOSE_PUBNUB_CONVERSATION);

var switchToChannel = exports.switchToChannel = (0, _reduxActions.createAction)(_ActionTypes2.default.SWITCH_PUBNUB_CHANNEL);

var callOnceForChannel = (0, _underscore.memoize)(function (channel, fn) {
  return fn();
}, function (channel) {
  return channel;
});

function recievedPrivateOpenChannel(message) {
  return function (dispatch) {
    var _message$message = message.message,
        channel = _message$message.channel,
        timetoken = _message$message.timetoken;

    var newChannel = channel;

    var timestamp = (0, _pubNubHelpers.getTimestampFromToken)(timetoken);

    callOnceForChannel(channel, function () {
      return (0, _pollFunctionWithExponentialBackoff2.default)({
        fn: function fn() {
          return dispatch((0, _ChatHistoryActions.fetchChatHistory)({ channel: channel, startTime: timestamp }));
        },
        limit: 6
      });
    });

    dispatch((0, _ConversationsActions.openConversationForNewChannel)({
      channel: newChannel,
      timestamp: timestamp
    }));
    dispatch((0, _ConversationsActions.fetchVisitorForChannel)(newChannel));
  };
}

var receivedCommandMessage = exports.receivedCommandMessage = (0, _reduxActions.createAction)(_ActionTypes2.default.RECEIVED_COMMAND_MESSAGE, function (message) {
  return { message: message };
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/actions/ChatActions.js
// module id = 80
// module chunks = 0 1